import React from 'react';
import { Shield } from 'lucide-react';
import { LeafDivider, Section } from './Shared';
import { HerbSprig } from './HealingIcons';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-97" data-mp="3gh3q6bfwg0dk">
    <div className="glass-panel p-8 md:p-12 rounded-3xl text-center border-brand-purple/40 bg-white/85 shadow-sm" data-id="element-98" data-mp="32oe11y52qfc8">
      <Shield className="w-14 h-14 md:w-16 md:h-16 text-brand-purple mx-auto mb-6" data-id="element-99" data-mp="36qhh702ou83u" />
      <h2 className="text-xl md:text-3xl font-display font-bold mb-4 text-brand-purpleDark" data-id="element-100" data-mp="3ueih5klswg7n">
        🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
      </h2>
      <p className="text-brand-text mb-4 text-base md:text-lg" data-id="element-101" data-mp="37xuse6oxwgy">
        Abres los volúmenes. Aplicas los protocolos. Los usas en tu consultorio.
      </p>
      <p className="text-brand-text mb-6 text-base md:text-lg" data-id="element-102" data-mp="3qcniknv98gxk">
        Si en 7 días no es lo que esperabas: devolución del 100% sin
        formularios, sin complicaciones, sin preguntas.
      </p>
      <LeafDivider className="my-6" data-id="element-103" data-mp="2eyjq5m4bf0um" />
      <p className="font-medium text-brand-purple text-sm md:text-base" data-id="element-104" data-mp="2ezl35w4w5xez">
        Tasa de devoluciones: menos del 1%.
      </p>
    </div>
  </Section>;
export const Footer = () => <footer className="bg-brand-purpleDark text-white/85 py-12 border-t border-brand-gold/20" data-id="element-105" data-mp="3gbijyk51v9y4">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-106" data-mp="3v8rgrtd4h5x8">
      <div className="mb-8" data-id="element-107" data-mp="3q8wu620dr2hz">
        <div className="flex items-center justify-center gap-2 mb-3" aria-hidden="true" data-id="element-108" data-mp="3q7lr64erdyrx">
          <HerbSprig className="w-6 h-6 opacity-80" color="#A6D93B" data-id="element-109" data-mp="81yvkel2tq1v" />
          <HerbSprig className="w-8 h-8" color="#C9A961" data-id="element-110" data-mp="3474fms9a7yq" />
          <HerbSprig className="w-6 h-6 opacity-80" color="#A6D93B" data-id="element-111" data-mp="33nlc2qvddj4" />
        </div>
        <h3 className="font-display font-bold text-2xl text-brand-goldLight mb-2" data-id="element-112" data-mp="hrih5s06by0f">
          🌿 LUMEN AKASHA™
        </h3>
        <p className="text-white/75" data-id="element-113" data-mp="cuihpzxtxtia">
          El sistema clínico N°1 para terapeutas de fitoterapia en
          Latinoamérica.
        </p>
        <p className="text-white/75 mt-2" data-id="element-114" data-mp="msg7irvc7yd0">
          Porque trabajar con las plantas medicinales con excelencia no debería
          costarte la seguridad de tu consultorio.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8 mb-12 text-sm" data-id="element-115" data-mp="yto901jxadwu">
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-goldLight transition-colors" data-id="element-116" data-mp="13sipgwuf3qds">
          📧 soportelumenakasha@gmail.com
        </a>
        <a href="https://instagram.com/lumen.akasha" className="hover:text-brand-goldLight transition-colors" data-id="element-117" data-mp="1clumffvoy6sl">
          📲 @lumen.akasha
        </a>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-goldLight transition-colors" data-id="element-118" data-mp="1hj4dt12n4sj2">
          🌐 www.lumenakasha.com
        </a>
      </div>

      <div className="text-xs text-white/50 space-y-2" data-id="element-119" data-mp="1rj4yorg5rgpd">
        <p data-id="element-120" data-mp="1rgsfkaynz0aq">
          © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>

      <div className="mt-8" data-id="element-121" data-mp="3tarpot01vblu">
        <p className="text-sm font-serif italic text-brand-goldLight/70" data-id="element-122" data-mp="2af3rlmvaexi1">
          🌿 "El terapeuta que tiene un sistema aplica con confianza. El que
          aplica con confianza genera resultados. El que genera resultados,
          crece."
        </p>
      </div>
    </div>
  </footer>;